// extracted by mini-css-extract-plugin
export default {"text-input":"YQ8oU9uuIh9MjZQKpykf"};